import type { ReactNode } from "react";
import estilos from "./SoloLectores.module.css";

/** Texto que solo leen los lectores de pantalla (completa un botón o un rótulo visual). */
export function SoloLectores({ children }: { readonly children: ReactNode }) {
  return <span className={estilos.oculto}>{children}</span>;
}

export const claseSoloLectores = estilos.oculto;
